
import ConfirmationOverlay from '../../../components/ConfirmationOverlay.vue';
import { defineComponent, PropType } from 'vue';
import globalConstants from '../../../shared/globalConstants';
import { ActionTypes } from '@/store/actionTypes';
import { MutationTypes } from '@/store/mutationTypes';
import FbaApiError from '@/types/FbaApiError';
import { elapsedTimeInSecondsSince, isNullOrUndefined } from '@/shared/helpers';
import { DateTime } from 'luxon';
import { mapGetters } from 'vuex';
import { AssociationType } from '@/types/AssociationType';

export default defineComponent({
    components: {
        ConfirmationOverlay,
    },
    data(): {
        company: string;
        popupStage: number;
        hasAccepted: boolean;
        trailerNumber: string;
    } {
        return {
            company: '',
            popupStage: 1,
            hasAccepted: true,
            trailerNumber: '',
        };
    },
    props: {
        association: {
            type: String as PropType<AssociationType>,
            required: true,
        },
    },
    created(): void {
        this.trailerNumber = this.$route.params.trailerNumber as string;
        this.company = this.$route.params.company as string;
    },
    computed: {
        ...mapGetters({
            trailerAssessmentMeta: 'trailerAssessmentMeta',
        }),
        confirmationShown(): boolean {
            return this.$route.query.confirmation === 'rejectwithdamage';
        },
        assistanceCompany(): string {
            return this.company === 'knight'
                ? globalConstants.trailer.assistance.knight
                : globalConstants.trailer.assistance.swift;
        },
    },
    methods: {
        onReject(): void {
            this.$store.dispatch(ActionTypes.CLEAR_QUERY_PARAM_AND_ROUTE, {
                routeToName: 'TrailerAssessment',
                omitParam: 'confirmation',
            });
        },
        async onAccept(): Promise<void> {
            const response = await this.postAssessment();
            if (response === false || isNullOrUndefined(response)) {
                this.onReject();
                return;
            }

            this.$router.push({
                name: 'TrailerNotFit',
                query: { trailerNumber: this.trailerNumber },
            });
        },
        async postAssessment(): Promise<boolean> {
            const hasPhotos = this.$store.getters.trailerPhotosCount > 0;
            const assessmentResponse = await this.$store.dispatch(
                ActionTypes.POST_TRAILER_ASSESSMENT,
                {
                    trailerNumber: this.trailerNumber,
                    trailerCompany: this.company,
                    eventName: this.association,
                    hasPhotos,
                    source: globalConstants.trailer.trailerAssessment.source,
                    entryPoint:
                        globalConstants.trailer.trailerAssessment.entryPoints
                            .attach,
                }
            );

            if (assessmentResponse instanceof FbaApiError) {
                this.$store.commit(
                    MutationTypes.SET_ERROR,
                    assessmentResponse as FbaApiError
                );
                return false;
            }

            if (
                assessmentResponse?.didSucceed &&
                assessmentResponse?.assessmentId &&
                hasPhotos
            ) {
                await this.$store.dispatch(
                    ActionTypes.SUBMIT_TRAILER_PHOTOS,
                    assessmentResponse.assessmentId
                );
            }

            return assessmentResponse?.didSucceed;
        },
    },
});
